import { render, staticRenderFns } from "./UiButtonOptions.vue?vue&type=template&id=ffe6d838&scoped=true&"
import script from "./UiButtonOptions.vue?vue&type=script&lang=js&"
export * from "./UiButtonOptions.vue?vue&type=script&lang=js&"
import style0 from "./UiButtonOptions.vue?vue&type=style&index=0&id=ffe6d838&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffe6d838",
  null
  
)

export default component.exports